<template>
  <div :class="$style.slideshow">
    <transition-group
      :class="$style.slidesContainer"
      tag="ul"
      @enter="enter"
      @leave="leave">
      <li
        v-show="i == current"
        v-for="(image, i) in images"
        :class="$style.slide"
        :key="image.src">
        <div :style="{ backgroundImage: `url(${image.src})` }">
          <img class="u-visuallyhidden" v-lazy="image.src" :alt="image.alt">
        </div>
      </li>
    </transition-group>
    <div :class="$style.leftArrow" v-if="current !== 0">
      <ArrowButton :action="prevSlide" :direction="'left'"></ArrowButton>
    </div>
    <div :class="$style.rightArrow" v-if="current !== (images.length - 1)">
      <ArrowButton :action="nextSlide" :direction="'right'"></ArrowButton>
    </div>
  </div>
</template>

<script>
import gsap from 'gsap'
import ArrowButton from '@/components/ArrowButton'

export default {
  props: ['images'],

  components: {
    ArrowButton
  },

  data() {
    return {
      current: 0
    }
  },

  methods: {
    enter(el, done) {
      gsap.fromTo(el, 0.7, {
        autoAlpha: 0
      }, {
        xPercent: 0,
        autoAlpha: 1,
        ease: gsap.Expo.easeInOut,
        onComplete: done
      })
    },
    leave(el, done) {
      gsap.fromTo(el, 1, {
        autoAlpha: 1
      }, {
        autoAlpha: 0,
        ease: gsap.Expo.easeInOut,
        onComplete: done
      })
    },
    nextSlide() {
      if (this.current === (this.images.length - 1)) return
      this.current += 1
    },
    prevSlide() {
      if (this.current === 0) return
      this.current -= 1
    }
  },
}
</script>

<style module lang="scss">
.slideshow {
  position: relative;
  overflow: hidden;
  margin: $standard-margin 0;
}

.slide {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  width: 100%;
  height: 100%;
  opacity: 1;

  > div {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    display: block;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
}

.slidesContainer {
  position: relative;
  width: 60%;
  margin: 0 auto;

  &::after {
    content: "";
    display: block;
    width: 100%;
    padding-bottom: 50%;
  }
}

.leftArrow,
.rightArrow {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  display: flex;
  align-items: center;
}

.leftArrow {
  left: 20px;
}

.rightArrow {
  right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/SimpleCarousel.vue